// Known, common override_governance paths, grouped for the "Add path" picker
// (AddGovernancePathModal) - mirrors Client Overrides' AddOverrideModal in
// shape, but this is a governance-*authoring* surface (picking which glob
// patterns exist at all) rather than a per-firm value picker, so the source
// list here is a small hand-maintained set of the paths this platform
// actually supports today (configs/schemas/global_defaults.schema.json's own
// numeric_bounds precedent), not a live traversal of product_types/
// document_types data. A "Custom path" fallback in the same modal covers
// anything not in this list - this screen must stay usable for a path added
// to the platform after this list was last updated.
export interface GovernancePathTemplate {
  group: string
  path: string
  label: string
}

export const KNOWN_GOVERNANCE_PATH_TEMPLATES: GovernancePathTemplate[] = [
  { group: 'Product Types', path: 'product_types.*.limits.max_documents', label: 'Max documents' },
  { group: 'Product Types', path: 'product_types.*.limits.max_total_pages', label: 'Max total pages' },
  { group: 'Product Types', path: 'product_types.*.limits.max_pdf_size_mb', label: 'Max PDF size (MB)' },
  {
    group: 'Document Types',
    path: 'document_types.*.fields.*.acceptance.min_confidence',
    label: 'Field min confidence',
  },
]

// Humanized label for a known path, else null (caller falls back to
// displaying the raw path itself, monospace).
export function describeGovernancePath(path: string): string | null {
  return KNOWN_GOVERNANCE_PATH_TEMPLATES.find((template) => template.path === path)?.label ?? null
}
